import { makeObservable } from "mobx";
import { RootStore } from "./RootStore";
import { TransportService } from "../services/TransportService";
import DataStore from "./DataStore";
import { ClientFindRequest, ClientSaveRequest } from "../models/Client";
import { Auth } from "../models/Auth";

class ClientStore extends DataStore {
  rootStore: RootStore;

  constructor(transportService: TransportService, rootStore: RootStore) {
    super(transportService);
    this.rootStore = rootStore;

    makeObservable(this, {});
  }

  findClient = async (req: ClientFindRequest) => {
    const token = "";

    try {
      this.clearError("findClient");
      this.setLoading("findClient");
      const res = await this.transportService.postWithToken(
        req,
        `/clients/find`,
        token
      );
    } catch (e) {
      console.error(e);
      this.setError("findClient");
      return;
    } finally {
      this.clearLoading("findClient");
    }
  };

  getAuth = async () => {
    return { clientId: 1, token: "" } as Auth;
  };

  getClient = async (clientId: number) => {
    const token = "";

    try {
      this.clearError("getClient");
      this.setLoading("getClient");
      const res = await this.transportService.getWithToken(
        `/clients/${clientId}`,
        token
      );
    } catch (e) {
      console.error(e);
      this.setError("getClient");
      return;
    } finally {
      this.clearLoading("getClient");
    }
  };

  saveClient = async (clientSaveRequest: ClientSaveRequest) => {
    const token = "";

    try {
      this.clearError("saveClient");
      this.setLoading("saveClient");
      const res = await this.transportService.postWithToken(
        clientSaveRequest,
        "/clients",
        token
      );
    } catch (e) {
      console.error(e);
      this.setError("saveClient");
      return;
    } finally {
      this.clearLoading("saveClient");
    }
  };
}

export default ClientStore;
